import { render, staticRenderFns } from "./TagIndex.vue?vue&type=template&id=1412b566&scoped=true"
import script from "./TagIndex.vue?vue&type=script&lang=js"
export * from "./TagIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1412b566",
  null
  
)

export default component.exports